import { render } from "./Change_log_record.vue?vue&type=template&id=45242160"
import script from "./Change_log_record.vue?vue&type=script&lang=js"
export * from "./Change_log_record.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__